import AboutMe from "../components/about-me-module/about-me-module";


export default function WhoWeAre() {
  return (
    <div>
      <AboutMe />
    </div>
  )
}